import * as React from 'react';

import { IControlSchema, IControlSchemaBase } from '../../core/Controls';
import {
  breakLine,
  Component,
  getRandomKey,
  I18NString,
  isNullOrEmpty,
} from '../helpers/Utils';
import { Strings } from '../i18n/messages';
import { IDispatcher } from '../helpers/Dispatcher';

interface IServiceTableColumn {
  title: I18NString;
}

export interface IServiceTableSchema extends IControlSchemaBase {
  columns: IServiceTableColumn[];
  value: any[];
}

export interface IServiceTableProps {
  schema: IServiceTableSchema;
  api: any;
}

class ServiceTable extends Component<IServiceTableProps, object> {
  componentDidMount() {
    if (!isNullOrEmpty(this.props.schema.value)) {
      this.props.schema.value.sort((l, r) => r.timestamp - l.timestamp);
    }
  }

  public render() {
    if (isNullOrEmpty(this.props.schema.value)) {
      return <div className="alert alert-info">{this.tr(Strings.EMPTY)}</div>;
    }

    const rows = [];
    for (const value of this.props.schema.value) {
      const row = [];
      for (const i in value.value) {
        if (Object.prototype.hasOwnProperty.call(value.value, i)) {
          let column = value.value[i];
          if (typeof column === 'string') {
            column = breakLine(column);
          } else if (typeof column === 'object') {
            const url = this.props.api.getFileUrl(
              this.props.schema.id,
              column.fileName,
              value.timestamp,
            );
            column = (
              <a target="_blank" href={url} rel="noreferrer">
                {column.fileName}
              </a>
            );
          }
          row.push(<td key={getRandomKey()}>{column}</td>);
        }
      }

      rows.push(<tr key={getRandomKey()}>{row}</tr>);
    }

    const headers = this.props.schema.columns.map((column) => (
      <th key={this.tr(column.title)}>{this.tr(column.title)}</th>
    ));

    return (
      <table className="table table-striped table-bordered">
        <thead>
          <tr>{headers}</tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    );
  }
}

export function createServiceTable(
  schema: IControlSchema,
  api: any,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  dispatcher: IDispatcher = null,
): React.ReactElement<any> {
  return <ServiceTable schema={schema as IServiceTableSchema} api={api} />;
}
